import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getNavigationForgePersonalSettingsPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { forgePersonalSettingsRoute } from '@jira/router-routes__forge-routes/src/forgePersonalSettingsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ForgePersonalSettingsPage, {
	LazyForgePersonalSettingsPage,
} from './ui/personal-settings/index.tsx';

export const forgePersonalSettingsRouteEntry: Route = createEntry(
	forgePersonalSettingsRoute,
	() => ({
		// eslint-disable-next-line no-restricted-syntax
		component: ForgePersonalSettingsPage,
		layout: globalLayout,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [...getNavigationResources(), ...getNavigationForgePersonalSettingsPageResources()],
		forPaint: [LazyAtlassianNavigation, LazyForgePersonalSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
